"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const localization_repository_1 = require("./localization.repository");
let LocalizationService = class LocalizationService {
    constructor(localizationRepository) {
        this.localizationRepository = localizationRepository;
    }
    async getUserLocalization(userId) {
        try {
            return await this.localizationRepository.getUserLocalization(userId);
        }
        catch (error) {
            throw new Error(`Failed to retrieve localization: ${error.message}`);
        }
    }
    async getOrganizationLocalization(organisation_id) {
        try {
            return await this.localizationRepository.getOrganizationLocalization(organisation_id);
        }
        catch (error) {
            throw new Error(`Failed to retrieve organization localization: ${error.message}`);
        }
    }
};
exports.LocalizationService = LocalizationService;
exports.LocalizationService = LocalizationService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof localization_repository_1.LocalizationRepository !== "undefined" && localization_repository_1.LocalizationRepository) === "function" ? _a : Object])
], LocalizationService);
